import SidebarStyles from "./Sidebar.module.scss";
import colors from "tailwindcss/colors";
import menuSvg from "../../assets/sidebar/menu.svg";
import logoutSvg from "../../assets/sidebar/logout.svg";
import { useAppDispatch, useAppSelector } from "../../hooks/store";
import { openCloseVmoBotThunk } from "../../modules/vscDashboard/store/dashboard.thunk";
import VmoBot from "../../modules/vscDashboard/Pages/vmoBot/VmoBot";
import VmoBotImg from "../../modules/vscDashboard/Pages/vmoBot/VmoBotImg";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Dropdown from "../Dropdown/Dropdown";
import Tooltip from "../Tooltip/Tooltip";
import Typography from "../Typography/Typography";
import Accordian from "../Accordian/Accordian";
import { useOutsideClick } from "../../hooks/common";
import { logout } from "../../common/common";
import orionLogo from "../../assets/Orion Logo-4x.png";
import OrionLogo from "../../assets/images/orion_logo.png";
import orbitLogo from "../../assets/images/orbit_logo.svg";
import OrbitLogo from "../../assets/images/OrbitLogo.png";
import { ROUTES } from "../../common/constants";
import ProfileButton from "../ProfileButton/ProfileButton";
import { ProfileData } from "../../common/common.model";
import { Button } from "@mui/material";
import OrbitTextLogo from "../../assets/orbit_text_logo.svg";
import { getProjectMappings } from "../../services/common.service";
import OrionGreenSvg from "../../assets/images/orion_green_icon.svg";
import SourcingHubSvg from "../../assets/images/sourcing_hub_icon.svg";
import VeriozonVSvg from "../../assets/images/verizon_logo.svg";
import VerizonSvg from "../../assets/images/VerizonLogo.svg";

const Sidebar = ({ sidebarContent }: any) => {
  const [activeOption, setActiveOption] = useState("");
  const [sideBarData, setSideBarData] = useState(sidebarContent);
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const [projectName, setProjectName] = useState("");
  const navigate = useNavigate();
  const path = window.location.pathname;
  const dispatch = useAppDispatch();
  const { vmoBot } = useAppSelector(
    (state) => state.rootReducer.vscDashboardReducer
  );
  const sideBarRef = useRef<HTMLDivElement | null>(null);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const profileData = useAppSelector(
    (store) => store?.rootReducer?.userInfoReducer?.profileData?.data
  );
  const [profileAnchorEl, setProfileAnchorEl] = useState<HTMLElement | null>(
    null
  );
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const profileContainerRef = useRef<HTMLDivElement>(null);

  // Handle opening the profile popover
  const handleProfileOpen = (event: React.MouseEvent<HTMLElement>) => {
    // Use the container as the anchor element
    if (profileContainerRef.current) {
      setProfileAnchorEl(profileContainerRef.current);
      setIsProfileOpen(true);
    }
  };

  // Handle closing the profile popover
  const handleProfileClose = () => {
    setIsProfileOpen(false);
  };

  const handleOpenBot = () => {
    dispatch(openCloseVmoBotThunk(!vmoBot.open));
    setIsSidebarExpanded(false);
  };

  const userData = useAppSelector(
    (store) => store?.rootReducer?.userInfoReducer?.profileData?.data
  );

  const handleSideBarExpansion = () => {
    setIsSidebarExpanded(!isSidebarExpanded);
  };

  const handleSidebarOptionClick = (optionKey: string) => {
    const optionData = sideBarData?.[optionKey];
    if (!optionData?.childNavs) {
      navigate(optionData?.url);
      setIsSidebarExpanded(false);
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      sideBarRef.current &&
      !sideBarRef.current.contains(event.target as Node)
    ) {
      setIsSidebarExpanded(false);
    }
  };

  useEffect(() => {
    const fetchProjectName = async () => {
      try {
        const response = await getProjectMappings();
        if (
          response &&
          response.project_names &&
          response.project_names.length > 0
        ) {
          setProjectName(response.project_names[0]);
        }
      } catch (error) {
        console.error("Error fetching project name:", error);
      }
    };

    fetchProjectName();
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  });

  useEffect(() => {
    const keys = sidebarContent ? Object.keys(sidebarContent) : null;
    let temp: any = {};
    keys?.forEach((key: any) => {
      if (
        userData?.roles?.some((role) =>
          sidebarContent[key]?.showFor?.includes(role?.name)
        )
      ) {
        temp[key] = sidebarContent[key];
      }
    });
    setSideBarData(temp);
  }, [sidebarContent, userData]);

  useEffect(() => {
    setActiveOption("");
    const keys = sideBarData ? Object.keys(sideBarData) : null;
    keys?.forEach((key: any) => {
      const data = sideBarData?.[key];
      if (data?.url === path || data?.supportUrls?.includes(path))
        setActiveOption(key);
    });
  }, [path, sideBarData]);

  // const treeItems =
  //   sideBarData &&
  //   Object.keys(sideBarData).map((key: any, index: number) => {
  //     if (!sideBarData?.[key]?.childNavs) {
  //       return {
  //         id: `${index}`,
  //         label: sideBarData?.[key]?.title,
  //       };
  //     } else {
  //       return {
  //         id: `${index}`,
  //         label: sideBarData?.[key]?.title,
  //         children: Object.keys(sideBarData?.[key]?.childNavs)?.map(
  //           (child, childIndex) => {
  //             const parent = sideBarData?.[key]?.childNavs;
  //             return {
  //               id: `${index}.${childIndex}`,
  //               label: parent?.[child]?.title,
  //             };
  //           }
  //         ),
  //       };
  //     }
  //   });

  const handleLogout = () => {
    logout();
  };

  const handleLogoClick = () => {
    navigate(ROUTES.dashboard);
  };

  return (
    <div
      className={`${SidebarStyles.sidebar} ${
        isSidebarExpanded ? `${SidebarStyles.active}` : ""
      }`}
      ref={sideBarRef}
      style={{
        background: colors.white,
      }}
    >
      <div
        className={SidebarStyles.logo}
        style={{ justifyContent: !isSidebarExpanded ? "center" : "" }}
        onClick={handleLogoClick}
      >
        {/* {isSidebarExpanded ? 
          // <img src={OrbitLogo} alt="" className={SidebarStyles.expandedLogo}/>:
          // <img src={orbitLogo} alt="" />
          <img src={OrionLogo} alt="" className={SidebarStyles.expandedLogo}/>:
          <img src={orionLogo} alt="" />
        } */}
        <div className={SidebarStyles.logoContainer}>
          {projectName === "Orion" ? (
            isSidebarExpanded ? (
              <img
                src={OrionLogo}
                alt="Orion Logo"
                className={SidebarStyles.expandedLogo}
              />
            ) : (
              <img src={orionLogo} alt="Orion Logo" />
            )
          ) : projectName === "SourcingHub" ? (
            isSidebarExpanded ? (
              <img
                src={require("../../assets/Orion-GSA.svg").default}
                alt="Orion GSA Logo"
                className={SidebarStyles.expandedLogo}
                style={{ height: "48px" }}
              />
            ) : (
              <img src={orionLogo} alt="Orion Logo" />
            )
          ) : isSidebarExpanded ? (
            <img
              src={OrbitLogo}
              alt="Orbit Logo"
              className={SidebarStyles.expandedLogo}
            />
          ) : (
            <img src={orbitLogo} alt="Orbit Logo" />
          )}
        </div>
      </div>

      <div
        className={SidebarStyles.sidebarContentHeader}
        onClick={handleSideBarExpansion}
      >
        <img src={menuSvg} alt="" />
        <Typography
          style={{  }}
          className={SidebarStyles.optionTitle}
        >
          Menu
        </Typography>
      </div>

      <div className={SidebarStyles.horzLine}></div>

      <div
        className={`${SidebarStyles.sidebarOptionsContainer} ${
          isSidebarExpanded ? SidebarStyles.expanded : ""
        }`}
      >
        {sideBarData &&
          Object.keys(sideBarData)?.map((sidebarOptionKey: string, idx) => {
            const sidebarOptionData = sideBarData?.[sidebarOptionKey];
            const hasSubMenu =
              isSidebarExpanded && sidebarOptionData?.childNavs?.length > 0;
            const isActive = activeOption === sidebarOptionKey;
            if (!profileData?.isPowerUser && sidebarOptionKey === "admin")
              return null;
            return (
              <div
                key={sidebarOptionKey}
                className={`${SidebarStyles.sidebarImgContainer} ${
                  isActive ? SidebarStyles.sidebarOptionActive : ""
                } ${isSidebarExpanded ? SidebarStyles.active : ""} ${
                  hasSubMenu ? SidebarStyles.subMenuBackground : ""
                }`}
                onClick={() => handleSidebarOptionClick(sidebarOptionKey)}
              >
                {sidebarOptionData?.childNavs ? (
                  !isSidebarExpanded ? (
                    <Dropdown
                      trigger="hover"
                      placement="bottomRight"
                      items={[
                        ...sidebarOptionData?.childNavs?.map((nav: any) => {
                          return {
                            key: nav?.title,
                            label: (
                              <div
                                ref={dropdownRef}
                                className={SidebarStyles.sideBarHoverSubMenu}
                              >
                                <img src={nav?.active} alt="" />
                                <Typography fontSize={12} fontWeight={400}>
                                  {nav?.title}
                                </Typography>
                              </div>
                            ),
                            onClick: () => {
                              navigate(nav?.url);
                              setIsSidebarExpanded(false);
                            },
                          };
                        }),
                      ]}
                    >
                      <div className={SidebarStyles.menuImageTitle}>
                        <img
                          key={"sidebarcontentImg" + idx}
                          src={
                            isActive
                              ? sidebarOptionData?.active
                              : sidebarOptionData.inactive
                          }
                          alt=""
                          height="20px"
                          width="20px"
                        />
                        <Typography className={SidebarStyles.optionTitle}>
                          {sidebarOptionData?.title}
                        </Typography>
                      </div>
                    </Dropdown>
                  ) : (
                    <>
                      <Accordian
                        defaultOpen={false}
                        theme="sidebar"
                        className={SidebarStyles.Accordian}
                        title={
                          <div
                            style={{
                              display: "flex",
                              gap: "8px",
                              alignItems: "center",
                            }}
                          >
                            <img
                              key={"sidebarcontentImg" + idx}
                              src={
                                isActive
                                  ? sidebarOptionData?.active
                                  : sidebarOptionData.inactive
                              }
                              alt=""
                              height="20px"
                              width="20px"
                            />
                            <Typography fontSize={12} fontWeight={400}>
                              {sidebarOptionData?.title}
                            </Typography>
                          </div>
                        }
                      >
                        <AccordianChild
                          data={sidebarOptionData}
                          setIsSidebarExpanded={setIsSidebarExpanded}
                          path={path}
                        />
                      </Accordian>
                    </>
                  )
                ) : (
                  <Tooltip title={sidebarOptionData?.title} placement="right">
                    <div className={SidebarStyles.menuImageTitle}>
                      <img
                        key={"sidebarcontentImg" + idx}
                        src={
                          isActive
                            ? sidebarOptionData?.active
                            : sidebarOptionData.inactive
                        }
                        alt=""
                        height="20px"
                        width="20px"
                      />
                      <Typography
                        className={SidebarStyles.optionTitle}
                        fontSize={12}
                        fontWeight={400}
                      >
                        {sidebarOptionData?.title}
                      </Typography>
                    </div>
                  </Tooltip>
                )}
              </div>
            );
          })}
      </div>

      {profileData ? (
        <div
          ref={profileContainerRef}
          className={`${SidebarStyles.logoutContainer} ${
            isSidebarExpanded ? SidebarStyles.active : ""
          }`}
          style={{ cursor: "pointer" }}
          // onClick={handleProfileOpen}
        >
          <ProfileButton
            profileData={profileData as ProfileData}
            isOpen={isProfileOpen}
            anchorEl={profileAnchorEl}
            onOpen={handleProfileOpen}
            onClose={handleProfileClose}
          />
          {isSidebarExpanded && (
            <Typography className={SidebarStyles.optionTitle}>
              {`${profileData.given_name} ${profileData.family_name}`}
            </Typography>
          )}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

const AccordianChild = (props: any) => {
  const { data, setIsSidebarExpanded, path, handleShowContent } = props;
  const navigate = useNavigate();

  useEffect(() => {
    data?.childNavs?.forEach((item: any) => {
      if (item?.url === path) {
        handleShowContent(true);
        return;
      }
    });
  }, []);

  return (
    <>
      {data?.childNavs?.map((item: any) => {
        return (
          <div
            key={item?.url}
            className={item?.url === path ? `${SidebarStyles.childActive}` : ""}
            onClick={() => {
              navigate(item?.url);
              setIsSidebarExpanded(false);
            }}
            style={{ padding: "8px 12px" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                style={{ width: "20px", height: "20px" }}
                src={item?.active}
                alt=""
              />
              <Typography fontSize={12} fontWeight={400}>
                {item?.title}
              </Typography>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Sidebar;
